import ErrorBoundary from '@/components/common/ErrorBoundary';
import { AppProvider } from '@/contexts/AppContext';
import { usePageContext } from '@/core/hooks/page-context';

import { createRoot } from 'react-dom/client';
import UserSignupForm from '../components/UserSignupForm';
import { useEffect } from 'react';

interface UserSignupPageContext {
  id: string;
}

const UserSignupFormPage = () => {
 const { id } = usePageContext<UserSignupPageContext>();


  useEffect(()=> {
    console.log("UserSignupFormPage => ", id);
    
  },[])
 
  return (
    <AppProvider>
      <ErrorBoundary>
        <UserSignupForm id={id} />
      </ErrorBoundary>
    </AppProvider>
  );
};

const root = createRoot(document.getElementById('UserSignupFormPage')!);

root.render(<UserSignupFormPage />);